<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="mall_pageTopWrap">
      <div class="pageArticleDatail_Inner">
        <p class="pageArticleDatail_tit">{{statusData.StylingData[0].styling_title}}</p>
        <p class="pageArticleDatail_susTit">{{statusData.StylingData[0].styling_sub_title}}</p>
        <div
          class="pageArticleDatail_editorMobile"
          v-html = "statusData.StylingData[0].styling_editor_mobile"/>
        <div
          class="pageArticleDatail_editorPc"
          v-html = "statusData.StylingData[0].styling_editor"/>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_styling_one_use
} from '../../ETC/Axios.vue'

export default {
  name: 'StylingDetail',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        StylingData: [{
          styling_title: '',
          styling_sub_title: '',
          styling_editor: '',
          styling_editor_mobile: ''

        }]
      })
    }
  },
  mounted () {
    get_styling_one_use(this.$route.query.styling_ID).then(result_data => {
      if (result_data.length === 0) {
        alert('잘못된 접근입니다.')
        history.back()
      } else {
        this.statusData.StylingData = result_data
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Styling/StylingDetail.vue